import {
  Scale, TrendingUp, Home, Briefcase, Landmark, LineChart,
  Sparkles, PenLine, Globe2, Users, HeartPulse, type LucideIcon,
} from 'lucide-react'

export interface AgentMeta {
  type: string
  icon: LucideIcon
  color: string
  bg: string
}

/** Les 11 agents spécialisés G BACK — méta-données UI partagées. */
export const AGENTS: AgentMeta[] = [
  { type: 'legal',         icon: Scale,      color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
  { type: 'economic',      icon: TrendingUp, color: '#22c55e', bg: 'rgba(34,197,94,0.12)' },
  { type: 'logistics',     icon: Home,       color: '#3b82f6', bg: 'rgba(59,130,246,0.12)' },
  { type: 'investment',    icon: Briefcase,  color: '#f59e0b', bg: 'rgba(245,158,11,0.12)' },
  { type: 'rights',        icon: Landmark,   color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)' },
  { type: 'monitoring',    icon: LineChart,  color: '#06b6d4', bg: 'rgba(6,182,212,0.12)' },
  { type: 'predictions',   icon: Sparkles,   color: '#ec4899', bg: 'rgba(236,72,153,0.12)' },
  { type: 'writing',       icon: PenLine,    color: '#84cc16', bg: 'rgba(132,204,22,0.12)' },
  { type: 'cultural',      icon: Globe2,     color: '#f97316', bg: 'rgba(249,115,22,0.12)' },
  { type: 'social',        icon: Users,      color: '#14b8a6', bg: 'rgba(20,184,166,0.12)' },
  { type: 'psychological', icon: HeartPulse, color: '#a855f7', bg: 'rgba(168,85,247,0.12)' },
]

export const getAgentMeta = (type: string): AgentMeta =>
  AGENTS.find((a) => a.type === type) ?? AGENTS[0]
